import {
  Box,
  SwipeableDrawer as MuiSwipeableDrawer,
  SwipeableDrawerProps as MuiSwipeableDrawerProps,
} from "@mui/material";
import { RefObject } from "react";

import { theme } from "../../mui-customs/Theme";

export interface SwipeableDrawerProps extends MuiSwipeableDrawerProps {
  containerRef?: RefObject<HTMLDivElement>;
}

export const SwipeableDrawer = ({
  open,
  children,
  containerRef,
  ...props
}: SwipeableDrawerProps) => {
  return (
    <MuiSwipeableDrawer
      anchor={"bottom"}
      open={open}
      sx={{
        "& .MuiPaper-root": {
          borderTopLeftRadius: "6px",
          borderTopRightRadius: "6px",
          height: "90vh",
        },
        display: "flex",
        flexDirection: "column",
        "& form": {
          flex: 1,
        },
      }}
      {...props}
    >
      <Box
        sx={{
          height: "5px",
          width: "39px",
          borderRadius: "6px",
          backgroundColor: theme.grey1[200],
          mb: 2,
          mt: 2,
          mx: "auto",
        }}
      />
      <Box
        ref={containerRef}
        sx={{
          height: "calc(90vh - 5px)",
          overflowY: "auto",
          "& > form": {
            minHeight: "100% !important",
          },
          "& > div": {
            minHeight: "100% !important",
          },
        }}
      >
        {children}
      </Box>
    </MuiSwipeableDrawer>
  );
};
